import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Bug } from 'lucide-react';
import { useConsoleCapture } from '../../hooks/useConsoleCapture';
import { BugReportModal } from './BugReportModal';

export function BugReportButton({ testId = 'bug-report-button' }: { testId?: string }) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const captureConsole = useConsoleCapture();

  const pageUrl = window.location.href;
  const routePath = location.pathname + location.search + location.hash;

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="relative flex h-9 w-9 items-center justify-center rounded-lg text-amber-600 hover:bg-amber-50 sm:h-11 sm:w-11"
        aria-label="Hata Bildir"
        title="Hata Bildir"
        data-testid={testId}
      >
        <Bug className="h-4 w-4 sm:h-5 sm:w-5" />
      </button>

      <BugReportModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        captureConsole={captureConsole}
        routePath={routePath}
        pageUrl={pageUrl}
      />
    </>
  );
}
